const ApplicationInfo = window.SIMPL.ApplicationInfo;

export default function GetApplicationInfoData(type,no,dataKey) {
    // jsonが読み込めていない場合orjsonに定義されていない場合
    if(ApplicationInfo == null || ApplicationInfo.length <= 0) return null;

    // noが未設定
    if(no === undefined || no === null|| no === "") return null;

    var typeDatas = ApplicationInfo[type];
    var typeData = typeDatas.find(x => x.no === no);

    return typeData[dataKey];
}